import { createContext } from 'react'

const IntlContext = createContext()
export const IntlContextProvider = IntlContext.Provider
export const IntlContextConsumer = IntlContext.Consumer